<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-data-table :headers="headers" :items="designation_list" dense class="elevation-1 mytable" :search="search">
      <template v-slot:top>
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Designation Details</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row dense justify="center">
          <v-col sm="3" md="3" cols="12">
          </v-col>
          <v-col sm="6" md="6" cols="12">
            <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
          </v-col>
          <v-col sm="3" md="3" cols="12">

            <span style="width: 20px"> </span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn small class="mb-2 button" v-on="on">New Designation</v-btn>
              </template>
              <v-card>
                <v-card-title class="toolbar">
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field v-model="editedItem.designation" persistent-hint :disabled="editedIndex != -1"
                          :hint="editedIndex==-1?'For example :: Director, Dean, HOD, Teacher':'noneditable'"
                          :filled="editedIndex==-1?false:true" label="Designation"
                          :error="errorMsg.designation?true:false"
                          :error-messages="errorMsg.designation?'Required':''"></v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if='editedIndex != -1'>
                        <v-checkbox dense v-model="editedItem.isactive" color="success" label="Active"></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="button" @click="close">Cancel</v-btn>
                  <v-btn class="button" @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>

      </template>

      <template v-slot:item.isactive="{ item }">
        <span v-if="item.isactive">
          <v-icon class="mr-2  v-icon-size" color="success">mdi-check-circle-outline</v-icon>
        </span>
        <span v-else>
          <v-icon class="mr-2  v-icon-size" color="error">mdi-close-circle-outline</v-icon>
        </span>
      </template>

      <template v-slot:item.action="{ item }">
        <div>
          <v-avatar style="" size="25" class="edit-avatar">
            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">
              edit
            </v-icon>
          </v-avatar>
        </div>
        <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
      </template>
      <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
    </v-data-table>
  </div>
</template>

<script>
import axios from 'axios'
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
    data: () => ({
      errorMsg:{
        designation: false
        
      },
      search: '',
      // extraBreadcrumbItems: [
       
      // ],
      // breadcrumbClass: "breadcrumb-style1",
       snackbar_msg: "",
    color: "",
    snackbar: false,
      dialog: false,
      headers: [
        {
          text: 'Designation',align: 'left',sortable: true,value: 'designation',
        },
        {
          text: 'Active',align: 'left',sortable: true,value: 'isactive',
        },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      designation_list: [],
      editedIndex: -1,
      editedItem: {
        designation: '',
        isactive:true
      },
      defaultItem: {
        designation: '',
        isactive:true
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Designation' : 'Edit Designation'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    // created () {
    //   this.initialize()
    // },
    mounted(){
      axios
      .post("/roleManagement/designation")
      .then(res => {
        if (res.data.msg == "200") {
          //window.alert(res.data.msg)
          this.designation_list = res.data.designation_list
          this.load = true;
        } else {
          window.console.log(res.data.msg)
        }
      })
      .catch(error => {
        window.console.log(error);
      });
    },
    methods: {
    initializeErrorMsgFalse(){
      this.errorMsg.designation=false;
    },
     showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
      editItem (item) {
        this.editedIndex = this.designation_list.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
        //window.alert(item)
      },

      // deleteItem (item) {
      //   const index = this.designation_list.indexOf(item)
      //   confirm('Are you sure you want to delete this item?') && this.designation_list.splice(index, 1)
      // },

      close () {
        this.dialog = false
        this.initializeErrorMsgFalse();
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) 
        {
          if(this.isValidated())
         {
          axios
          .post("/roleManagement/editDesignation", this.editedItem)
          .then(res => {
            if (res.data.msg == "200") {
               Object.assign(this.designation_list[this.editedIndex], this.editedItem)
               this.showSnackbar(
                  "#4caf50",
                  "Designation Updated Successfully..."
                ); // show snackbar on success
            }
          })
          .catch(error => {
            window.console.log(error);
          });
            this.close()
         }
        } 
        else 
        {
          if(this.isValidated())
         {
           axios
          .post("/roleManagement/saveDesignation", this.editedItem)
          .then(res => {
            if (res.data.status.code == "SUCCESS") {
              //window.alert(res.data.status.code)
              this.designation_list.push(this.editedItem)
              this.showSnackbar(
                  "#4caf50",
                  "Designation Added Successfully..."
                ); // show snackbar on success
            }
            else if(res.data.status.code == "NA"){
                //window.alert(res.data.status.code)
               this.showSnackbar("#b71c1c", "Designation Already Present!!!"); // show snackbar on error    
            }
          })
          .catch(error => {
            window.console.log(error);
          });
          this.close()
         }

        }
        
      }, // end of save()
       isValidated(){
      // alert('I am in isValidated()'+this.editedItem.name +"||" +this.editedItem.usertype.id +"||"+this.editedItem.roletype.id)
      if(this.editedItem.designation)
       { 
           return true; 
       }
      else{
            if(!this.editedItem.designation)
            {
              this.errorMsg.designation=true
            }
           
        return false;
      }  
     }, // .....end of isValidated()
   }
  }
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size{
  font-size: 20px;
}
.edit-avatar{
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover{
  background-color: #b0bec5;
}
.edit-v-icon{
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover{
  color: white;
}
</style>